module.exports = __webpack_public_path__ + "img/e4baddaf8ba1bb0b8e897a6cafca5b90.png";